"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaccineExemptionRequestDrawer = exports.VaccineExemptionRequestDrawerComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const luxon_1 = require("luxon");
const hui_1 = require("@mit/hui");
const react_image_file_resizer_1 = __importDefault(require("react-image-file-resizer"));
const pdfjsLib = __importStar(require("pdfjs-dist/es5/build/pdf"));
const pdf_worker_entry_1 = __importDefault(require("pdfjs-dist/es5/build/pdf.worker.entry"));
const ImageCrop_1 = require("./../../common/ImageCrop");
const MedicalApi_1 = __importDefault(require("../../api/MedicalApi"));
const mobx_react_1 = require("mobx-react");
const VaccineExemptionRequestDrawerComponent = (props) => {
    // const { auth } = useStoreState((state) => state.VaccineExemptionModel)
    // const { setReload, setAlertMessage, setNewDocUploaded } = useStoreActions((action) => action.VaccineExemptionModel)
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    // const [personDetails, setPersonDetails] = useState<ApiPersonDetail | null>()
    const [expiryDate, setExpiryDate] = (0, react_1.useState)(undefined);
    // const [expiryDate, setExpiryDate] = useState<moment.Moment | undefined>(undefined);
    const [expiryFrom, setExpiryFrom] = (0, react_1.useState)("ALL");
    const [isLoading, setLoading] = (0, react_1.useState)(false);
    const [fileContentType, setFileContentType] = (0, react_1.useState)("image/jpeg");
    const [showCropModal, setShowCropModal] = (0, react_1.useState)(false);
    const [showPreview, setShowPreview] = (0, react_1.useState)(false);
    const [displayData, setDisplayData] = (0, react_1.useState)({});
    const [hasImage, setHasImage] = (0, react_1.useState)(false);
    const [exemptionDocUrl, setExemptionDocUrl] = (0, react_1.useState)({ image_key: "", signed_url: "" });
    const [file, setFile] = (0, react_1.useState)();
    const [fileChanged, setFileChanged] = (0, react_1.useState)(false);
    const [fileName, setFileName] = (0, react_1.useState)("");
    const [isUploading, setUploading] = (0, react_1.useState)(false);
    // const [agreementTicked, setAgreementTicked] = useState(false)
    const [extContractorTicked, setExtContractorTicked] = (0, react_1.useState)(false);
    // const [religiousTicked, setReligiousTicked] = useState(false)
    const [exemptionType, setExemptionType] = (0, react_1.useState)();
    const [exemptionReason, setExemptionReason] = (0, react_1.useState)("");
    const [personInfo, setPersonInfo] = (0, react_1.useState)();
    const [errorAlerts, setErrorAlerts] = (0, react_1.useState)([]);
    const exemptionFroms = [
        {
            text: "COVID-19",
            enum: "COVID",
        },
        {
            text: "Flu Shot",
            enum: "FLU",
        },
        {
            text: "All",
            enum: "ALL",
        },
    ];
    const tomorrowDate = luxon_1.DateTime.local().plus({ days: 1 }).toJSDate();
    const tomorrow = {
        year: tomorrowDate.getFullYear(),
        month: tomorrowDate.getMonth() + 1,
        day: tomorrowDate.getDate()
    };
    const handleExpiryFromChange = (newValue) => {
        setExpiryFrom(newValue);
    };
    // const religiousExemptText =
    // 	'To be eligible for a religious exemption you must demonstrate that your refusal to be vaccinated is based on a sincere belief that is religious in nature. A refusal to be vaccinated does not qualify for a religious exemption if it is based on personal preference, concerns about the possible effects of the vaccine, or political opinions. Any intentional misrepresentation to MIT may result in denial of this request and further disciplinary action.'
    // const religiousExemptLabel = 'This vaccination is inconsistent with my sincerely held religious beliefs'
    const medicalExemptionText = "You may upload medical documentation from your health care provider here or your provider can securely send documentation directly to Human Resources. For directions on submitting information to HR, employees or their providers should contact: hr-dsmlo@mit.edu for Campus employees, or covidvaxexemption@ll.mit.edu for Lincoln Laboratory employees.";
    (0, react_1.useEffect)(() => {
        setLoading(false);
        // vaccineController.fetchExemptionTypes().then(res => {
        // 	if (res.error) {
        // 		console.log(res)
        // 	} else {
        // 		setExemptionTypes(res.data)
        // 		setLoading(false)
        // 	}
        // })
    }, []);
    (0, react_1.useEffect)(() => {
        // setAgreementTicked(false)
        setExtContractorTicked(false);
        // setReligiousTicked(false)
        setFile(undefined);
        setHasImage(false);
        setExemptionReason("");
        setExemptionType(undefined);
        setPersonInfo(undefined);
        setFileName("");
        setDisplayData({});
        setShowPreview(false);
        setErrorAlerts([]);
    }, [props.show]);
    (0, react_1.useEffect)(() => {
        loadPerson();
    }, [props.personDetails]);
    const resizeFile = (file) => {
        return new Promise((resolve) => {
            react_image_file_resizer_1.default.imageFileResizer(file, // Is the file of the image which will resized
            800, // Is the maxWidth of the resized new image.
            1000, // Is the maxHeight of the resized new image.
            "JPEG", // Is the compressFormat of the resized new image.
            100, // Is the quality of the resized new image.
            0, // Is the degree of clockwise rotation to apply to uploaded image.
            (uri) => {
                // Is the callBack function of the resized new image URI.
                resolve(uri);
            }, "base64" // Is the output type of the resized new image.
            );
        });
    };
    const onSaveImage = () => {
        const blob = b64toBlob(displayData.image_url);
        setFile(blob);
        setShowPreview(false);
        setUploading(false);
        saveImage(blob);
    };
    const closeImageCropped = () => {
        setShowCropModal(false);
        setUploading(false);
        setFileChanged(false);
        setFile("");
        setDisplayData({
            image_url: "",
        });
    };
    const handleImageCropped = (blob, previewUrl) => {
        console.log(blob);
        setFile(blob);
        setDisplayData({
            image_url: previewUrl,
        });
        setShowCropModal(false);
        setUploading(false);
        saveImage(blob);
    };
    function b64toBlob(dataURI) {
        const byteString = atob(dataURI.split(",")[1]);
        const ab = new ArrayBuffer(byteString.length);
        const ia = new Uint8Array(ab);
        for (let i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return new Blob([ab], { type: "image/jpeg" });
    }
    const saveImage = (blob) => {
        MedicalApi_1.default.getExemptionDocumentUrl(exemptionDocUrl.image_key !== "" ? exemptionDocUrl.image_key : undefined, fileName, blob.type)
            .then((response) => {
            var _a, _b;
            setExemptionDocUrl({
                image_key: (_a = response.data) === null || _a === void 0 ? void 0 : _a.docKey,
                signed_url: (_b = response.data) === null || _b === void 0 ? void 0 : _b.signedUrl,
            });
        })
            .catch((err) => console.log(err));
    };
    const imageUpload = (fileData) => __awaiter(void 0, void 0, void 0, function* () {
        if (fileData.length >= 1 && fileData[0].type !== "application/pdf") {
            setUploading(true);
            const file = fileData[0];
            const image = yield resizeFile(file);
            setFileChanged(true);
            setHasImage(true);
            setFileName(fileData[0].name);
            setDisplayData({
                image_url: image,
            });
            setShowPreview(true);
        }
        else {
            setUploading(true);
            const file = fileData[0];
            var fileReader = new FileReader();
            pdfjsLib.GlobalWorkerOptions.workerSrc = pdf_worker_entry_1.default;
            fileReader.onload = function (e) {
                return __awaiter(this, void 0, void 0, function* () {
                    var typedarray = new Uint8Array(e.target.result);
                    const loadingTask = pdfjsLib.getDocument(typedarray);
                    const pdfDoc = yield loadingTask.promise;
                    const page = yield pdfDoc.getPage(1);
                    const viewport = page.getViewport({ scale: 1.0 });
                    var canvas = document.createElement("canvas"), ctx = canvas.getContext("2d");
                    var renderContext = {
                        canvasContext: ctx,
                        viewport: viewport,
                    };
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    const renderTask = page.render(renderContext);
                    yield renderTask.promise;
                    const image = canvas.toDataURL("image/jpeg");
                    setFileChanged(true);
                    setHasImage(true);
                    // setFileName(`${fileData[0].name.slice(0, fileData[0].name.indexOf('.'))}.jpg`)
                    if (fileData[0].type === "image/jpeg") {
                        setFileName(`${fileData[0].name.slice(0, fileData[0].name.indexOf("."))}.jpg`);
                    }
                    else if (fileData[0].type === "image/png") {
                        setFileName(`${fileData[0].name.slice(0, fileData[0].name.indexOf("."))}.png`);
                    }
                    setDisplayData({
                        image_url: image,
                    });
                    setShowPreview(true);
                });
            };
            fileReader.readAsArrayBuffer(file);
        }
    });
    const submitExemption = () => __awaiter(void 0, void 0, void 0, function* () {
        var _o, _p;
        const errorsArr = [];
        if (exemptionType === 3 && personInfo && personInfo.type !== "EMPLOYEE" && !hasImage) {
            // medical exemption, requires supporting docs if not an employee
            let drawerBody = document.getElementsByClassName("drawer")[0];
            drawerBody.scroll(0, 0);
            errorsArr.push("Please select a valid image");
            setErrorAlerts(errorsArr);
            return;
        }
        setLoading(true);
        let reqBody = {};
        if (exemptionDocUrl.image_key) {
            // if supporting docs
            reqBody = {
                type: exemptionType,
                reason: exemptionReason,
                imageKey: exemptionDocUrl.image_key,
                isExternalContractor: extContractorTicked,
                fileName: fileName,
                fileContentType: file.type,
                onBehalfMitId: (_o = props.personDetails) === null || _o === void 0 ? void 0 : _o.mit_id,
                expiryDate: (exemptionType === 1 || exemptionType === 4) ? expiryDate : undefined,
                exemptFrom: expiryFrom,
            };
        }
        else {
            // no supporting docs
            reqBody = {
                type: exemptionType,
                reason: exemptionReason,
                isExternalContractor: extContractorTicked,
                onBehalfMitId: (_p = props.personDetails) === null || _p === void 0 ? void 0 : _p.mit_id,
                expiryDate: (exemptionType === 1 || exemptionType === 4) ? expiryDate : undefined,
                exemptFrom: expiryFrom,
            };
        }
        // console.log('reqBody', reqBody)
        const haveUploadedDoc = () => __awaiter(void 0, void 0, void 0, function* () {
            // let fileNameInternal = fileName
            // if(file.type === 'image/jpeg' && fileName.substring(fileName.length-4) !== '.jpg'){
            //   fileNameInternal = `${fileName.substring(0,fileName.length-4)}.jpg`
            //   setFileName(fileNameInternal)
            // }
            // else if(file.type === 'image/png' && fileName.substring(fileName.length-4) !== '.png'){
            //   fileNameInternal = `${fileName.substring(0,fileName.length-4)}.png`
            //   setFileName(fileNameInternal)
            // }
            // saveImage()
            // console.log(exemptionDocUrl)
            // console.log(file)
            // console.log(fileNameInternal)
            if (file && fileChanged) {
                return yield MedicalApi_1.default.uploadExemptionProof(exemptionDocUrl.signed_url, file, fileName);
            }
            return true;
        });
        // New exemption request POST
        // Submit a new exemption request
        const postExemptionReq = () => __awaiter(void 0, void 0, void 0, function* () { return yield MedicalApi_1.default.postExemptionRequest(reqBody); });
        // if (exemptionType === 3 /* Medical */) {
        if (hasImage) {
            // has supporting documentation
            haveUploadedDoc()
                .then((result) => postExemptionReq())
                .then((resp) => {
                if (resp.error) {
                    errorsArr.push("An error occured while uploading the request.");
                    setLoading(false);
                    setErrorAlerts(errorsArr);
                    return;
                }
                else {
                    // setReloadVaccineData(true)
                    // setIsExemptionReqSubmitted(true)
                    // setActiveDrawer(ActiveDrawer.None)
                    setLoading(false);
                    props.setReFetchPersonExemption(true);
                    props.done();
                }
            })
                .catch((err) => {
                errorsArr.push("An error occured while uploading the request.");
                setLoading(false);
                setErrorAlerts(errorsArr);
                return;
            });
        }
        else {
            // dont have supporting documentation
            postExemptionReq()
                .then((resp) => {
                if (resp.error) {
                    errorsArr.push("An error occured while uploading the request.");
                    setLoading(false);
                    setErrorAlerts(errorsArr);
                    return;
                }
                else {
                    // setReloadVaccineData(true)
                    // setIsExemptionReqSubmitted(true)
                    // setActiveDrawer(ActiveDrawer.None)
                    setLoading(false);
                    props.setReFetchPersonExemption(true);
                    props.done();
                }
            })
                .catch((err) => {
                errorsArr.push("An error occured while uploading the request.");
                setLoading(false);
                setErrorAlerts(errorsArr);
                return;
            });
        }
    });
    const exemptionsBtnsData = (_b = (_a = props.holds) === null || _a === void 0 ? void 0 : _a.exemptionTypes) === null || _b === void 0 ? void 0 : _b.map((exemption, index) => {
        var _a, _b, _c, _d;
        const isActive = exemptionType === exemption.id;
        const enabled = ((_b = (_a = props.holds) === null || _a === void 0 ? void 0 : _a.features) === null || _b === void 0 ? void 0 : _b.includes(exemption.roleCreate)) || ((_d = (_c = props.holds) === null || _c === void 0 ? void 0 : _c.features) === null || _d === void 0 ? void 0 : _d.some((r) => exemption.roleApprove.includes(r)));
        return ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsxs)("button", Object.assign({ className: "btn btn-primary elevation-0", id: isActive ? "exemption-btn-active" : "exemption-btn", "aria-label": exemption.name, onClick: () => {
                    if (enabled)
                        setExemptionType(exemption.id);
                    // console.log(exemption.id)
                }, disabled: !enabled }, { children: [(0, jsx_runtime_1.jsx)(hui_1.Icon, { type: "light", icon: exemption.icon.icon }), (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { fontWeight: "bold", fontSize: "1em" } }, { children: exemption.name })), (0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", Object.assign({ style: { fontSize: "0.8em" } }, { children: exemption.description }))] })) }, `exemptBtn-${exemption.id}`));
    });
    const loadPerson = () => {
        if (props.personDetails) {
            MedicalApi_1.default.fetchPerson(props.personDetails.krb_name).then((resp) => {
                setPersonInfo(resp.data);
            });
        }
    };
    const ImageUploadComponents = () => {
        var _a, _b, _c;
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.ImageUpload
                // onChange={file => null}
                , { 
                    // onChange={file => null}
                    onChange: (file) => {
                        if (file.length > 0) {
                            imageUpload(file);
                        }
                        else {
                            setUploading(false);
                        }
                    }, text: ((_c = (_b = (_a = props.holds) === null || _a === void 0 ? void 0 : _a.appText) === null || _b === void 0 ? void 0 : _b.find((text) => text.id === "vaccine.exemption.support-upload.title")) === null || _c === void 0 ? void 0 : _c.text) || "", label: "Exemption supporting documentation", noClear: false, imageUrl: displayData.image_url, 
                    // imageUrl={exemptionDocUrl.signed_url}
                    isLoading: isUploading, editButtonAriaLabel: "Edit Uploaded image.", displayButtons: true }), (0, jsx_runtime_1.jsx)(hui_1.TemplateModal, { name: "imagePreview", show: showPreview, autoHeight: true, 
                    // // onClose={() => onCloseCropModal()}
                    bodyAlignment: hui_1.TemplateModalAlignment.Center, size: hui_1.TemplateModalSize.Large, header: (0, jsx_runtime_1.jsx)(hui_1.Text, { content: "Image preview", type: hui_1.TextType.Heading2 }), body: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)("img", { src: displayData.image_url, style: { maxWidth: "100%", maxHeight: "65vh" }, alt: "" }) }), footer: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(hui_1.ButtonBar, { buttons: [
                                {
                                    padded: true,
                                    icon: "crop",
                                    type: hui_1.ButtonType.Ghost | hui_1.ButtonType.Secondary,
                                    text: "Crop Image",
                                    onClick: () => {
                                        setShowCropModal(true);
                                        setShowPreview(false);
                                    },
                                    customAriaLabel: "Crop Image.",
                                },
                                {
                                    padded: true,
                                    icon: "save",
                                    text: "Save Image",
                                    onClick: () => onSaveImage(),
                                    customAriaLabel: "Save Image.",
                                },
                            ] }) }) }), (0, jsx_runtime_1.jsx)(ImageCrop_1.ImageCrop, { showCropModal: showCropModal, uploadImage: displayData.image_url, onCloseCropModal: closeImageCropped, handleCropImage: handleImageCropped })] }));
    };
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: props.show && ((0, jsx_runtime_1.jsx)(hui_1.Drawer, { show: props.show, onClose: () => {
                // setShowFileUpload(false)
                props.onClose();
            }, className: "vaccine-request-drawer", contents: (0, jsx_runtime_1.jsx)("div", { children: isLoading ? ((0, jsx_runtime_1.jsx)(hui_1.ActionList, { isLoading: true, items: [] })) : ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [errorAlerts &&
                            errorAlerts.length > 0 &&
                            errorAlerts.map((er, index) => ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(hui_1.Alert, { text: er, type: "error" }) }, `er-${index}`))), props.personDetails && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.Spacer, {}), (0, jsx_runtime_1.jsx)("strong", { children: "Person: " }), `${(_c = props.personDetails) === null || _c === void 0 ? void 0 : _c.first_name} ${(_d = props.personDetails) === null || _d === void 0 ? void 0 : _d.last_name} (${(_e = props.personDetails) === null || _e === void 0 ? void 0 : _e.krb_name})`] })), (0, jsx_runtime_1.jsx)("hr", { className: "regular" }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "btn-padded" }, { children: exemptionsBtnsData })), (0, jsx_runtime_1.jsx)("hr", { className: "regular" }), (0, jsx_runtime_1.jsx)(hui_1.Label, { target: "exemptionReason", text: "Explain The Request" }), (0, jsx_runtime_1.jsx)(hui_1.TextArea, { name: "exemptionReason", placeholderText: exemptionReason, properties: {
                                "aria-label": "Explain your request",
                                value: exemptionReason,
                                id: "exemptionReason",
                            }, rows: 5, onChange: (e) => setExemptionReason(e.target.value) }), (0, jsx_runtime_1.jsx)(hui_1.Spacer, {}), (exemptionType === 1 || exemptionType === 4) ?
                            (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-group row" }, { children: [(0, jsx_runtime_1.jsx)("label", Object.assign({ htmlFor: 'form-date', className: "col-sm-4 text-right col-form-label" }, { children: "Expiry Date" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-8" }, { children: (0, jsx_runtime_1.jsx)(hui_1.CalendarInput, { minDate: tomorrow, onChange: (e) => setExpiryDate(e), id: "from-date" }) }))] })) : (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "form-group row" }, { children: [(0, jsx_runtime_1.jsx)("label", Object.assign({ className: "col-sm-4 text-right col-form-label" }, { children: "Exempted From" })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "col-sm-8" }, { children: (0, jsx_runtime_1.jsx)(hui_1.Dropdown, { width: 50, text: "", value: (_f = exemptionFroms.find((exemptionFrom) => exemptionFrom.enum === "COVID")) === null || _f === void 0 ? void 0 : _f.text, name: "exemptedFrom", dropdownItems: exemptionFroms.map((exemptionFroms) => {
                                            return {
                                                id: exemptionFroms.enum,
                                                icon: "",
                                                text: exemptionFroms.text,
                                                state: hui_1.DropDownState.None,
                                            };
                                        }), onChange: (itm) => {
                                            handleExpiryFromChange(itm.id);
                                        } }) }))] })), exemptionType && props.personDetails && personInfo && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("hr", { className: "regular" }), (0, jsx_runtime_1.jsx)(hui_1.Spacer, {}), (0, jsx_runtime_1.jsx)(hui_1.Text, { type: "h5", content: "Supporting Documentation", align: "center" }), (0, jsx_runtime_1.jsx)(hui_1.Spacer, { size: "2" }), personInfo.type === "EMPLOYEE" && exemptionType === 3 && ((0, jsx_runtime_1.jsx)(hui_1.Text, { align: "left", content: ((_j = (_h = (_g = props.holds) === null || _g === void 0 ? void 0 : _g.appText) === null || _h === void 0 ? void 0 : _h.find((text) => text.id === "vaccine.exemption.medical-support-upload.title")) === null || _j === void 0 ? void 0 : _j.text) || medicalExemptionText, italic: true, padded: true })), ["image/jpeg", ""].includes(fileContentType) && (0, jsx_runtime_1.jsx)(ImageUploadComponents, {}), fileName && fileContentType && displayData && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "text-center" }, { children: [console.log(fileContentType), fileContentType !== "image/jpeg" && ((0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary, text: `Upload new file`, icon: "cloud-upload", onClick: () => {
                                                setFileName("");
                                                setFileContentType("");
                                                setDisplayData({});
                                            } }))] }))), (0, jsx_runtime_1.jsxs)("div", Object.assign({ style: { maxWidth: 750, margin: "20px auto 0px" } }, { children: [(0, jsx_runtime_1.jsx)(hui_1.Spacer, {}), (0, jsx_runtime_1.jsx)("hr", { className: "regular" }), !["Current Employee", "Current Student"].includes(personInfo.personType) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(hui_1.Spacer, {}), (0, jsx_runtime_1.jsx)(hui_1.Checkbox, { label: ((_m = (_l = (_k = props.holds) === null || _k === void 0 ? void 0 : _k.appText) === null || _l === void 0 ? void 0 : _l.find((text) => text.id === "vaccine.exemption.extcontractor")) === null || _m === void 0 ? void 0 : _m.text) || "", name: "Exemption Agreement", onClick: () => setExtContractorTicked((extContractorTicked) => !extContractorTicked), checked: extContractorTicked, properties: {
                                                        "aria-label": "Exemption Agreement",
                                                    } }), (0, jsx_runtime_1.jsx)("hr", { className: "regular" })] })), (0, jsx_runtime_1.jsx)(hui_1.Button, { type: hui_1.ButtonType.Primary, text: "Submit", onClick: submitExemption, state: expiryFrom ? hui_1.ButtonState.Enabled : hui_1.ButtonState.Disabled })] }))] }))] })) }), size: hui_1.DrawerSize.Medium, footer: [], header: (0, jsx_runtime_1.jsx)(hui_1.Text, { type: hui_1.TextType.Heading3, content: "Vaccine Exemption" }), layout: hui_1.DrawerLayout.Hero, type: hui_1.DrawerType.Right })) }));
};
exports.VaccineExemptionRequestDrawerComponent = VaccineExemptionRequestDrawerComponent;
exports.VaccineExemptionRequestDrawer = (0, mobx_react_1.inject)("searchUser", "covidNav", "holds", "roles")((0, mobx_react_1.observer)(exports.VaccineExemptionRequestDrawerComponent));
